/* eu-col2.js (16 Oct 2026): collection pages with the icon tiles ("Mix 1 v2", canvas page "collections").
   Loaded by sections/main-collection.liquid on the Searchanise layout when snippets/eu-col-top.liquid printed tiles.
   1. Tiles: the tile that matches the address (?rb_tags=..., Searchanise's URL filter) is marked as chosen; tapping
      it again goes back to the whole collection.
   2. The advice-finder app's card (.ea-cta) moves into [data-eu-find]: beside the page title on wide screens, under the
      tiles on smaller ones (eu-col2.css).
   3. Product cards (Searchanise's): brand, the name without the model code, one line of key specs, the EU energy
      class arrow and "Product information sheet" next to the price (from /collections/<handle>?view=eu-cards, the
      same eur-o2-energy-state rule as the homepage), "Add to basket". An energy-labelled product whose class, label or
      sheet cannot be shown with confidence keeps its price (user, 17 Oct 2026) with "Energy label on the product page"
      under it.
   4. Filters: energy classes as arrows, true/false as Yes/No, Discount hidden, a one-value Product type hidden. The same
      in Searchanise's phone filter dialog.
   5. Results bar (17 Oct 2026): the product count, the filters in use as chips (from the rb_* URL filters) with
      "Clear all", a tidier sort list. On phones the sort and filter buttons stay pinned while scrolling (eu-col2.css).
   6. Brand row under the tiles (snippets/eu-col-brands): a brand adds to or comes off the brand filter and keeps the
      other filters in use; the chosen brands are marked.
   7. (18 Oct 2026) Card stars from the Feefo rating, a "Save" pill only where the saving is lawful (since 24 Oct: 8.),
      and "Show more" with progress. Photos: the theme's eu-fit.js.
   8. (24 Oct 2026; user: "why are collections showing wrong price?") Card prices from Shopify, not Searchanise's index:
      prices() puts the eu-cards price "p" (snippets/eu-card-data.liquid) on the card, and the struck price and saving
      only where the product page shows them ("w", snippets/eu-was-price.liquid: compare-at and the 30-day prior price
      both above today's price; the struck price is the prior price; S.I. 597/2022 Reg 5A). Searchanise's own "Old price"
      and "Save" (its compare-at copy) never show: replaced by "w", removed without it, hidden (eu-col2.css) on a card that
      has no entry yet or at all. The humm line is worked out again from the live price. */
(function () {
  'use strict';
  var d = document, W = window;
  var top = d.querySelector('.eu-top');
  if (!top || W.__euCol2) return;
  W.__euCol2 = true;
  var CAT = top.getAttribute('data-eu-cat') || '';
  var SCALE = top.getAttribute('data-eu-scale') || 'ag';

  /* ---------- 1. tiles ---------- */
  function markTiles() {
    var ps = new URLSearchParams(location.search);
    Array.prototype.forEach.call(d.querySelectorAll('.eu-top [data-eu-q]'), function (a) {
      var q = a.getAttribute('data-eu-q'), i = q.indexOf('='), on = ps.get(q.slice(0, i)) === q.slice(i + 1);
      if (!a.hasAttribute('data-eu-href')) a.setAttribute('data-eu-href', a.getAttribute('href'));
      a.classList.toggle('is-on', on);
      if (on) { a.setAttribute('aria-current', 'true'); a.setAttribute('href', location.pathname); }
      else { a.removeAttribute('aria-current'); a.setAttribute('href', a.getAttribute('data-eu-href')); }
    });
  }
  markTiles();
  W.addEventListener('popstate', markTiles);

  /* ---------- 2. the product finder card ---------- */
  var moves = 0;
  function moveFinder() {
    var slot = d.querySelector('.eu-top [data-eu-find]');
    if (!slot) return true;
    var cta = d.querySelector('.ea-cta');
    if (!cta) return false;
    if (cta.parentNode !== slot && moves < 6) { moves++; slot.appendChild(cta); }
    slot.parentNode.classList.add('has-find');
    /* Otto's avatar leads the card (user, 16 Oct 2026: "use an avatar of Otto") */
    var inner = cta.querySelector('.ea-cta__inner'), otto = top.getAttribute('data-eu-otto');
    if (inner && otto && !inner.querySelector('.eu-otto')) {
      var im = d.createElement('img');
      im.className = 'eu-otto'; im.src = otto; im.alt = ''; im.width = 128; im.height = 125; im.decoding = 'async';
      inner.insertBefore(im, inner.firstChild);
    }
    return true;
  }

  /* ---------- energy arrow: the same drawing as snippets/eu-energy-arrow.liquid ---------- */
  var COLS = ['#00a651', '#50b848', '#bfd730', '#fff200', '#fdb913', '#f37021', '#ed1c24'];
  var FONT = "Calibri,Carlito,'Segoe UI','Helvetica Neue',Arial,sans-serif";
  function arrow(cls, scale) {
    cls = String(cls || '').toUpperCase().replace(/^RATING_/, '').trim();
    var letter = cls.charAt(0), plus = cls.slice(1);
    if (plus) scale = 'legacy';
    var order = scale === 'legacy' ? ['A+++', 'A++', 'A+', 'A', 'B', 'C', 'D'] : ['A', 'B', 'C', 'D', 'E', 'F', 'G'];
    var idx = order.indexOf(cls);
    if (idx < 0) { scale = 'plain'; idx = 'ABCDEFG'.indexOf(letter); }
    if (idx < 0) return '';
    var fill = COLS[idx];
    var big = '<text x="%X" y="50" dy=".35em" text-anchor="middle" font-family="' + FONT + '" font-weight="700" font-size="66" fill="#fff" stroke="#000" stroke-width="2.6" stroke-linejoin="round" paint-order="stroke">' + letter +
      (plus ? '<tspan font-size="38" dy="-.2em">' + plus + '</tspan>' : '') + '</text>';
    if (scale === 'ag') {
      return '<svg class="eu-earrow eu-earrow--ag" viewBox="0 0 182 100" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M1 1H39V99H1Z" fill="#fff" stroke="#000" stroke-width="2"/><path d="M39 1H138L180.5 50L138 99H39Z" fill="' + fill + '" stroke="#000" stroke-width="2"/>' +
        '<g fill="#000" font-family="' + FONT + '" font-weight="700" font-size="25" text-anchor="middle"><text x="20" y="25">A</text><text x="20" y="92">G</text></g>' +
        '<path d="M20 66V38M13.5 45L20 36.5L26.5 45" fill="none" stroke="#000" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>' + big.replace('%X', '88.5') + '</svg>';
    }
    var rw = [100, 108, 128, 148][plus.length] || 100, tip = rw + 42.5, vw = rw + 44, cx = rw / 2 + 0.5;
    return '<svg class="eu-earrow eu-earrow--' + scale + '" viewBox="0 0 ' + vw + ' 100" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M1 1H' + rw + 'L' + tip + ' 50L' + rw + ' 99H1Z" fill="' + fill + '" stroke="#000" stroke-width="2"/>' + big.replace('%X', String(cx)) + '</svg>';
  }
  function scaleText(k) { return k === 'legacy' ? 'A+++ to D' : 'A to G'; }
  /* 22 Oct 2026 (user: "show both classes A / B"): a product whose cavities carry different classes (eu-cards "cs" and
     "ls", main cavity first, snippets/eu-card-data.liquid) shows one arrow per cavity with a thin "/" between them, each
     opening its own cavity label; the information sheet stays single. Same drawing and size as the single arrow. */
  var CAV = ['main oven', 'second oven', 'third oven', 'fourth oven'];
  function multi(info) { return !!(info.cs && info.ls && info.cs.length > 1 && info.cs.length === info.ls.length); }
  function ears(info, name) {
    var g = el('span', 'eu-ears'), said = [];
    g.setAttribute('role', 'group');
    g.style.cssText = 'display:inline-flex;align-items:center;gap:3px;flex:none;line-height:0';
    info.cs.forEach(function (c, i) {
      if (i) {
        var s = el('span', 'eu-ears__sep', '/');
        s.setAttribute('aria-hidden', 'true');
        s.style.cssText = 'flex:none;font-size:15px;font-weight:400;line-height:1;color:#5B6472';
        g.appendChild(s);
      }
      var e = el('span', 'eu-ear', arrow(c, info.k || SCALE));
      e.setAttribute('role', 'link'); e.setAttribute('tabindex', '0'); e.setAttribute('data-href', info.ls[i]);
      e.setAttribute('aria-label', 'Energy class ' + c + ', ' + CAV[i] + ', scale ' + scaleText(info.k) + '. Opens the ' + CAV[i] + ' energy label for ' + name);
      g.appendChild(e);
      said.push(c + ' ' + CAV[i]);
    });
    g.setAttribute('aria-label', 'Energy class ' + said.join(', '));
    return g;
  }

  /* ---------- 3. product cards ---------- */
  var DATA = null;
  var HASR = false;   /* some product on the page has a rating */
  function take(p) {
    DATA = DATA || {};
    for (var k in p) if (Object.prototype.hasOwnProperty.call(p, k)) { DATA[k] = p[k]; if (p[k].rc) HASR = true; }
  }
  /* the collection's card data, 250 products a page: page 1 says how many pages there are, pages 2 to 4 then load
     together (20 Oct 2026; one after another before). Cards past the first 1,000 products are filled one by one (fill). */
  function page(n) {
    var u = location.pathname.replace(/\/$/, '') + '?view=eu-cards' + (n > 1 ? '&page=' + n : '');
    return fetch(u, { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (j) { take(j.p || {}); return j.pages || 1; });
  }
  function load() {
    return page(1).then(function (pages) {
      var more = [];
      for (var i = 2; i <= Math.min(pages, 4); i++) more.push(page(i).catch(function () {}));
      return Promise.all(more);
    });
  }
  /* a card whose product is not in the collection's data (past the first 1,000 of a big collection such as
     all-products): its own entry from /products/<handle>?view=eu-card, four at a time, once per product */
  var ASKED = {};
  function fill() {
    if (!DATA) return;
    var want = [];
    Array.prototype.forEach.call(d.querySelectorAll('#snize_results .snize-product a.snize-view-link'), function (a) {
      var h = ((a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/) || [])[1] || '';
      if (!h || ASKED[h] || DATA[h] || DATA[decodeURIComponent(h)]) return;
      ASKED[h] = 1; want.push(h);
    });
    var i = 0, open = 0, left = want.length;
    function next() {
      while (open < 4 && i < want.length) {
        var h = want[i++]; open++;
        fetch('/products/' + h + '?view=eu-card', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (j) { if (j && j.p) take(j.p); }, function () {})
          .then(function () { open--; if (--left === 0) all(); else next(); });
      }
    }
    next();
  }

  function tg(cls, re) { var m = cls.match(re); return m ? m[1] : ''; }
  function capf(s) { s = String(s || '').replace(/-/g, ' '); return s.charAt(0).toUpperCase() + s.slice(1); }
  function inch(t) { var m = t.match(/(\d{1,3}(?:\.\d)?)\s*(?:"|”|''|-?\s?inch)/i); return m ? m[1] + '"' : ''; }
  function kg(cls) { var v = tg(cls, /tag-load-capacity_(\d+(?:[.-]\d)?)kg/); return v ? v.replace('-', '.') + 'kg' : ''; }
  /* a collection without its own category (20 Oct 2026: every collection uses this page now) works out each card's
     kind from the card's own tags, so a mixed list such as Home appliances still gets the right key specs */
  function autoCat(c) {
    if (/tag-tablet-type_/.test(c)) return 'TAB';
    if (/tag-processor-model_/.test(c)) return 'LAP';
    if (/tag-screen-size_|tag-screen-technology_/.test(c)) return 'TV';
    if (/tag-dryer-type_/.test(c)) return 'DRY';
    if (/tag-spin-speed_/.test(c)) return 'WM';
    if (/tag-coffee-type_/.test(c)) return 'COF';
    if (/tag-fridge-capacity_/.test(c)) return 'FRI';
    if (/tag-place-settings_/.test(c)) return 'DSH';
    if (/tag-hob-type_/.test(c)) return 'HOB';
    if (/tag-fuel-type_/.test(c) && /tag-width_/.test(c)) return 'RNG';
    if (/tag-vacuum-type_/.test(c)) return 'VAC';
    if (/tag-self-emptying|tag-mop-function/.test(c)) return 'ROB';
    return '';
  }
  function SPEC(cls, ti) {
    var c = ' ' + cls + ' ', t = ti || '';
    switch (CAT || autoCat(c)) {
      case 'WM': {
        var rpm = tg(c, /tag-spin-speed_(\d+)rpm/), b = tg(c, /tag-build-type_(freestanding|integrated)/);
        return [kg(c), rpm ? (+rpm).toLocaleString('en-IE') + ' rpm' : '', capf(b)];
      }
      case 'TV': {
        var res = /tag-screen-technology_(?:4k|uhd)|\b(?:4k|uhd)\b/i.test(c + t) ? '4K' : (/full[- ]hd/i.test(c + t) ? 'Full HD' : (/hd[- ]ready/i.test(c + t) ? 'HD Ready' : ''));
        var tech = /oled/i.test(c + t) ? 'OLED' : /qned/i.test(c + t) ? 'QNED' : /qled/i.test(c + t) ? 'QLED' : /mini[- ]?rgb|micro rgb/i.test(c + t) ? 'Micro RGB' : /mini[- ]?led/i.test(c + t) ? 'Mini LED' : /nanocell|nano\d/i.test(c + t) ? 'NanoCell' : '';
        return [inch(t), res, tech];
      }
      case 'COF': {
        var ty = /coffee-type_bean/.test(c) ? 'Bean to cup' : /coffee-type_pods/.test(c) ? 'Pods' : /coffee-type_ground/.test(c) ? 'Espresso' : /coffee-type_filter/.test(c) ? 'Filter' : '';
        var w = tg(c, /tag-power_(\d{3,4})w/i);
        return [ty, w ? w + 'W' : ''];
      }
      case 'DRY': return [kg(c), /dryer-type_heat-pump/.test(c) ? 'Heat pump' : ''];
      case 'TAB': {
        var gb = tg(c, /tag-storage_(\d+(?:gb|tb))/);
        return [inch(t), gb.toUpperCase(), /tablet-type_ipad/.test(c) ? 'iPad' : (/tablet-type_android/.test(c) ? 'Android' : '')];
      }
      case 'FRI': {
        var pt = tg(c, /tag-product-type_([a-z-]+)/), l = tg(c, /tag-fridge-capacity_(\d+)l\b/);
        return [capf(pt), l ? l + ' litres' : '', /tag-frost-free_yes/.test(c) ? 'Frost free' : ''];
      }
      case 'ROB': {
        var f = [];
        if (/tag-self-emptying|tag-auto-dirt/.test(c)) f.push('Self-emptying');
        if (/tag-mop-function/.test(c)) f.push('Mop');
        if (/tag-pet-hair/.test(c)) f.push('Pet hair');
        return f.length ? f : ['Robot vacuum'];
      }
      case 'LAP': {
        var cpu = tg(c, /tag-processor-model_([a-z0-9-]+)/).replace(/-/g, ' ').replace(/\bamd\b/g, 'AMD').replace(/\b(intel|apple|core|ryzen|ultra|snapdragon|celeron|pentium|processor)\b/g, function (m) { return m.charAt(0).toUpperCase() + m.slice(1); }).replace(/\bm(\d)\b/g, 'M$1').replace(/\bai\b/g, 'AI').replace(/\bpro\b/g, 'Pro');
        var st = tg(c, /tag-storage_(\d+(?:gb|tb))/);
        return [inch(t), cpu, st.toUpperCase()];
      }
      case 'HOB': return [capf(tg(c, /tag-hob-type_([a-z]+)/)), (tg(c, /tag-width_(\d+)cm/) ? tg(c, /tag-width_(\d+)cm/) + 'cm' : ''), /tag-venting-hob/.test(c) ? 'Venting' : ''];
      case 'RNG': return [(tg(c, /tag-width_(\d+)cm/) ? tg(c, /tag-width_(\d+)cm/) + 'cm' : ''), capf(tg(c, /tag-fuel-type_([a-z-]+)/)), /tag-oven-type_double/.test(c) ? 'Two ovens' : ''];
      case 'DSH': {
        var ps = tg(c, /tag-place-settings_(\d+)/);
        return [ps ? ps + ' place settings' : '', capf(tg(c, /tag-build-type_(freestanding|integrated)/)), /tag-width_45cm/.test(c) ? 'Slimline 45cm' : ''];
      }
      case 'VAC': {
        var vt = tg(c, /tag-vacuum-type_([a-z-]+)/), mn = (t.match(/(\d{2,3})\s*(?:min|minute)/i) || [])[1];
        return [capf(vt), mn ? 'Up to ' + mn + ' min' : ''];
      }
    }
    return [];
  }

  function el(tag, cls, html) { var e = d.createElement(tag); e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }

  /* the arrow and the sheet sit inside Searchanise's card link: their clicks must not open the product page */
  var proxy = null;
  function openLabel(href) {
    if (!proxy) { proxy = el('a', 'o2-earrow eu-proxy'); proxy.target = '_blank'; proxy.rel = 'noopener'; proxy.style.display = 'none'; d.body.appendChild(proxy); }
    proxy.href = href;
    proxy.click();   /* eur-energy-pop.js opens the label in a pop-up where it can, else the new tab opens */
  }
  d.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('.eu-ear, .eu-pis') : null;
    if (!a || !a.closest('#snize_results')) return;
    e.preventDefault();
    e.stopPropagation();
    var href = a.getAttribute('data-href');
    if (a.classList.contains('eu-ear')) openLabel(href);
    else W.open(href, '_blank', 'noopener');
  }, true);

  /* five small navy stars, filled to the rating (yellow is kept for Offers, Otto and Save) */
  function stars(v) {
    var pct = Math.max(0, Math.min(100, (Number(v) || 0) / 5 * 100));
    var row = '<path d="M7 1l1.8 3.7 4 .6-2.9 2.8.7 4L7 10.2 3.4 12.1l.7-4L1.2 5.3l4-.6z"/>';
    var five = ''; for (var i = 0; i < 5; i++) five += '<g transform="translate(' + (i * 15) + ' 0)">' + row + '</g>';
    return '<span class="eu-stars" aria-hidden="true"><svg viewBox="0 0 74 14" class="eu-stars__bg">' + five + '</svg>' +
      '<span class="eu-stars__fg" style="width:' + pct.toFixed(1) + '%"><svg viewBox="0 0 74 14">' + five + '</svg></span></span>';
  }

  /* product photos are evened out by the theme's own eu-fit.js (it measures each photo and scales the product to fill
     the same share of its frame); eu-col2.css only makes the frame a little shorter */

  /* "Show more": a navy pill with "Showing 25 of 45" and a thin progress bar above it */
  function moreBar() {
    var pg = d.querySelector('#snize_results .snize-pagination'), a = pg ? pg.querySelector('.snize-pagination-load-more') : null;
    if (!a) return;
    var b = d.querySelector('#snize_results .snize-main-panel-collection-results-found b'), tot = b ? parseInt(b.textContent.replace(/\D/g, ''), 10) : 0;
    var n = d.querySelectorAll('#snize_results .snize-product').length;
    if (!tot || !n) return;
    var bar = pg.querySelector('.eu-prog'), txt = 'Showing ' + Math.min(n, tot) + ' of ' + tot, w = Math.min(100, n / tot * 100).toFixed(1) + '%';
    if (!bar) { bar = el('div', 'eu-prog', '<span class="eu-prog__t"></span><span class="eu-prog__bar"><i></i></span>'); a.parentNode.insertBefore(bar, a); }
    var t = bar.querySelector('.eu-prog__t'), i = bar.querySelector('i');
    if (t.textContent !== txt) t.textContent = txt;
    if (i.style.width !== w) i.style.width = w;
  }

  /* the brand already sits above the name, so "Samsung Series 5 9kg..." reads "Series 5 9kg..." (user, 17 Oct 2026).
     Letters and digits are compared, so "De'Longhi" matches the vendor "DeLonghi". */
  function noBrand(t, b) {
    var bn = String(b || '').toLowerCase().replace(/[^a-z0-9]/g, ''), acc = '', i = 0;
    if (!bn) return t;
    while (i < t.length && acc.length < bn.length) { var ch = t.charAt(i).toLowerCase(); if (/[a-z0-9]/.test(ch)) acc += ch; i++; }
    if (acc !== bn || /[a-z0-9]/i.test(t.charAt(i))) return t;
    var rest = t.slice(i).replace(/^[\s\-\u2013:|,]+/, '');
    return rest.length > 3 ? rest : t;
  }
  function decorate() {
    Array.prototype.forEach.call(d.querySelectorAll('#snize_results .snize-product'), function (card) {
      if (card.getAttribute('data-eu') === '1' && card.querySelector('.eu-spec, .eu-brand')) return;
      var a = card.querySelector('a.snize-view-link'), box = card.querySelector('.snize-overhidden');
      if (!a || !box) return;
      var handle = ((a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/) || [])[1] || '';
      var info = DATA ? DATA[decodeURIComponent(handle)] || DATA[handle] : null;
      var titleEl = card.querySelector('.snize-title');
      var full = titleEl ? (titleEl.getAttribute('data-eu-full') || titleEl.textContent) : '';
      var vend = info && info.b ? info.b : capf(((card.className.match(/snize-product-vendor-([^\s]+)/) || [])[1] || ''));
      if (titleEl && !titleEl.hasAttribute('data-eu-full')) {
        titleEl.setAttribute('data-eu-full', full);
        titleEl.setAttribute('title', full);
        titleEl.textContent = noBrand(full.split(' | ')[0].replace(/\s+-\s+(white|black|graphite|silver|grey|gray)$/i, function (m, col) { return ', ' + col.toLowerCase(); }), vend);
      }
      if (!box.querySelector('.eu-brand') && vend) box.insertBefore(el('span', 'eu-brand', esc(vend)), box.firstChild);
      if (!box.querySelector('.eu-spec')) {
        var sp = SPEC(card.className, full).filter(Boolean);
        if (sp.length) box.appendChild(el('span', 'eu-spec', esc(sp.join(' · '))));
      }
      if (info && !info.rc && HASR && !box.querySelector('.eu-rate')) {
        var rt0 = el('span', 'eu-rate is-empty'); rt0.setAttribute('aria-hidden', 'true');   /* keeps prices in line across a row */
        if (titleEl && titleEl.parentNode === box) box.insertBefore(rt0, titleEl.nextSibling); else box.appendChild(rt0);
      }
      if (info && info.rc && !box.querySelector('.eu-rate')) {
        var rt = el('span', 'eu-rate', stars(info.rv) + '<b>' + esc(String(info.rv)) + '</b><span>(' + esc(Number(info.rc).toLocaleString('en-IE')) + ')</span>');
        rt.setAttribute('aria-label', 'Rated ' + info.rv + ' out of 5 from ' + info.rc + ' reviews');
        if (titleEl && titleEl.parentNode === box) box.insertBefore(rt, titleEl.nextSibling); else box.appendChild(rt);
      }
      /* the yellow "Save" pill: prices() (24 Oct 2026), from the product page's struck price */
      var btn = card.querySelector('.snize-add-to-cart-button');
      if (btn) Array.prototype.forEach.call(btn.childNodes, function (n) { if (n.nodeType === 3 && /add to cart/i.test(n.nodeValue)) n.nodeValue = 'Add to basket'; });
      if (DATA && info) {
        var pl = card.querySelector('.snize-price-list');
        if (info.s === 'ok' && pl && !card.querySelector('.eu-ear')) {
          var name = esc(full.split(' | ')[0]);
          if (multi(info)) pl.appendChild(ears(info, name));
          else {
          var ear = el('span', 'eu-ear', arrow(info.c, info.k || SCALE));
          ear.setAttribute('role', 'link'); ear.setAttribute('tabindex', '0');
          /* the arrow opens the label; a product with only its information sheet opens that instead (17 Oct 2026) */
          ear.setAttribute('data-href', info.l || info.f);
          ear.setAttribute('aria-label', 'Energy class ' + info.c + ', scale ' + scaleText(info.k) + '. Opens the ' + (info.l ? 'energy label' : 'product information sheet') + ' for ' + name);
          pl.appendChild(ear);
          }
          if (info.f) {
            var pis = el('span', 'eu-pis', 'Product information sheet');
            pis.setAttribute('role', 'link'); pis.setAttribute('tabindex', '0'); pis.setAttribute('data-href', info.f);
            pis.setAttribute('aria-label', 'Product information sheet for ' + name + ', opens in a new tab');
            pl.parentNode.insertBefore(pis, pl.nextSibling);
          }
        } else if (info.s === 'skip' && !card.querySelector('.eu-nolabel')) {
          /* energy-labelled, but the class, label or sheet can't be shown with confidence. Until 17 Oct 2026 the card hid
             its price; the user asked for prices to show regardless, so the price and button stay and a line points to
             the product page for the label. */
          card.classList.add('eu-nolab');
          /* only when the product page has a label or sheet to look at; some products simply have none */
          if (info.h) box.appendChild(el('span', 'eu-nolabel', 'Energy label on the product page'));
        }
      }
      /* "0" until the card has its data, so a card filled later (fill) is decorated again */
      card.setAttribute('data-eu', DATA && info ? '1' : '0');
    });
  }
  /* ---------- 8. prices (24 Oct 2026) ----------
     Searchanise draws its card from its own copy of the catalogue, which lags a price change by about 15 minutes and
     carries the compare-at price as "Old price" / "Save". On every pass, for each card with an eu-cards entry:
       price          = "p" (Shopify, the variant the product page opens on);
       struck + saving = "w" and w - p, only when "w" is there (the product page's eu-was-price rule): the struck price
                        next to the price and the yellow "Save" pill, the one save message (user, 24 Oct 2026: "I want to
                        show saving pills"); Searchanise's own "Save" text is removed. Not gated on "sv" any more (that
                        also wanted compare-at within EUR 1 of the prior price); the pill stays hidden on an out-of-stock
                        card (eu-col2.css, user 17 Oct 2026), the struck price does not;
       no "w"         = no struck price, no "Old price", no "Save" anywhere on the card;
       humm           = again from "p": from EUR 5, "3 x EUR X interest-free" under EUR 500 (price / 3 to the cent),
                        "Spread the cost" from EUR 500 (searchanise-euronics-skin's rule, no rates).
     A card without an entry keeps Searchanise's price; its struck price and saving stay hidden (eu-col2.css, fails
     closed). Each write happens only when the card differs, so Searchanise's re-draws (filter, sort, "Show more") and our
     own MutationObserver pass settle at once. */
  function cents(c) { var s = (Math.round(c) / 100).toFixed(2).split('.'); return '€' + s[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + s[1]; }
  function setTxt(e, t) { if (e && e.textContent !== t) e.textContent = t; }
  function drop(e) { if (e && e.parentNode) e.parentNode.removeChild(e); }
  var HUMM = (function () {
    var s = d.querySelector('script[src*="/eu-col2.js"]'), u = s ? s.getAttribute('src') : '';
    return u ? u.replace(/eu-col2\.js(\?.*)?$/, 'snz-humm.png') : '';
  })();
  function cardInfo(card) {
    var a = card.querySelector('a.snize-view-link');
    var h = ((a && a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/) || [])[1] || '';
    if (!h || !DATA) return null;
    try { return DATA[decodeURIComponent(h)] || DATA[h] || null; } catch (e) { return DATA[h] || null; }
  }
  function prices() {
    Array.prototype.forEach.call(d.querySelectorAll('#snize_results .snize-product'), function (card) {
      var info = cardInfo(card), pr = card.querySelector('.snize-price'), pl = card.querySelector('.snize-price-list');
      var box = card.querySelector('.snize-overhidden');
      if (!pr || !pl || !box) return;
      if (!info || typeof info.p !== 'number') {   /* no entry (yet): Searchanise's price; its was/save hidden by eu-col2.css */
        if (card.classList.contains('eu-haswas')) card.classList.remove('eu-haswas');
        if (card.hasAttribute('data-eu-p')) card.removeAttribute('data-eu-p');
        return;
      }
      var p = info.p, w = typeof info.w === 'number' && info.w > p ? info.w : 0;
      if (card.getAttribute('data-eu-p') !== String(p)) card.setAttribute('data-eu-p', String(p));   /* checked against Shopify */
      /* (a) the price: Searchanise's first text node in .snize-price */
      var tn = null;
      for (var n = pr.firstChild; n; n = n.nextSibling) if (n.nodeType === 3 && /\S/.test(n.nodeValue)) { tn = n; break; }
      var pt = cents(p);
      if (!tn) pr.insertBefore(d.createTextNode(pt), pr.firstChild);
      else if (tn.nodeValue !== pt) tn.nodeValue = pt;
      var hs = pr.querySelector('.snize-highlight-saving-text'), dp = pl.querySelector('.snize-discounted-price');
      var lab = null;
      Array.prototype.forEach.call(pl.querySelectorAll('.snize-visually-hidden'), function (v) { if (!lab && /old price|was/i.test(v.textContent)) lab = v; });
      var pill = box.querySelector('.eu-save');
      if (w) {
        /* (b) the product page's struck price and saving */
        if (!card.classList.contains('eu-haswas')) card.classList.add('eu-haswas');
        if (!pr.classList.contains('snize-price-with-discount')) pr.classList.add('snize-price-with-discount');
        if (!dp) { dp = el('span', 'snize-discounted-price money'); pl.insertBefore(dp, pr.nextSibling); }
        if (!lab) { lab = el('span', 'snize-visually-hidden', 'Old price'); pl.insertBefore(lab, dp); }
        setTxt(dp, cents(w));
        drop(hs);   /* Searchanise's own "Save" text: the yellow pill is the one save message (user, 24 Oct 2026) */
        var st = 'Save ' + euro((w - p) / 100);
        if (!pill && pl.parentNode === box) { pill = el('span', 'eu-save'); box.insertBefore(pill, pl); }
        setTxt(pill, st);
      } else {
        /* (c) no lawful reduction: no struck price and no saving anywhere on the card */
        if (card.classList.contains('eu-haswas')) card.classList.remove('eu-haswas');
        if (pr.classList.contains('snize-price-with-discount')) pr.classList.remove('snize-price-with-discount');
        drop(dp); drop(lab); drop(hs); drop(pill);
        Array.prototype.forEach.call(pl.querySelectorAll('.snize-save-price-wrapper'), function (x) { if (x.textContent.trim()) x.textContent = ''; });
      }
      /* (d) humm, from the live price */
      var fin = card.querySelector('.snz-fin');
      if (p < 500) { drop(fin); return; }
      var ft = p < 50000 ? '3 × €' + (Math.round(p / 3) / 100).toFixed(2) + ' interest-free' : 'Spread the cost';
      if (!fin) {
        if (!HUMM) return;   /* searchanise-euronics-skin adds it from the price above */
        fin = el('div', 'snz-fin', '<img class="snz-logo-humm" src="' + esc(HUMM) + '" alt="humm" loading="lazy"><span></span>');
        pl.parentNode.insertBefore(fin, pl.nextSibling);
      }
      var fs = fin.querySelector(':scope > span');
      if (!fs) { fs = d.createElement('span'); fin.appendChild(fs); }
      if (fs.textContent !== ft) fs.innerHTML = p < 50000 ? '<b>3 × €' + (Math.round(p / 3) / 100).toFixed(2) + '</b> interest-free' : 'Spread the cost';
    });
  }

  /* stock line above the button (user, 17 Oct 2026), from what Searchanise draws:
     - "View product" instead of the basket button = out of stock: "Out of stock online", and the button reads
       "View details" so it is clear the product can still be opened;
     - its pre-order class (sold with none in stock) = "Available to order";
     - otherwise "In stock for delivery". */
  function stock() {
    Array.prototype.forEach.call(d.querySelectorAll('#snize_results .snize-product'), function (card) {
      var btns = card.querySelectorAll('.snize-buttons .snize-button'), out = false;
      Array.prototype.forEach.call(btns, function (b) {
        Array.prototype.forEach.call(b.childNodes, function (n) {
          if (n.nodeType !== 3) return;
          if (/view product/i.test(n.nodeValue)) { n.nodeValue = 'View details'; out = true; }
          else if (/view details/i.test(n.nodeValue)) out = true;
        });
      });
      var box = card.querySelector('.snize-overhidden');
      if (!btns.length || !box || box.querySelector('.eu-stock')) return;
      var pre = card.classList.contains('snize-product-pre-order');
      card.classList.add('eu-hasst');
      if (out) card.classList.add('eu-oosc');
      box.insertBefore(el('span', 'eu-stock ' + (out ? 'is-out' : pre ? 'is-order' : 'is-in'),
        out ? 'Out of stock online' : pre ? 'Available to order' : 'In stock for delivery'), box.querySelector('.snize-buttons'));
    });
  }
  /* keyboard: the role=link spans open like links */
  d.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var a = e.target.closest ? e.target.closest('.eu-ear, .eu-pis') : null;
    if (!a) return;
    e.preventDefault(); e.stopPropagation();
    if (a.classList.contains('eu-ear')) openLabel(a.getAttribute('data-href')); else W.open(a.getAttribute('data-href'), '_blank', 'noopener');
  }, true);

  /* ---------- 4. filters ---------- */
  function facetTitle(name) {
    var t = d.getElementById('snize_filters_block_' + name + '_title');
    return t ? t.textContent.replace(/,\s*\u20ac\s*$/, '').trim() : '';
  }
  function fixInput(inp, title) {
    var lab = inp.closest('label'), span = lab ? lab.querySelector(':scope > span.needsclick') : null;
    if (!span || span.getAttribute('data-eu') === '1') return;
    var txt = span.firstChild && span.firstChild.nodeType === 3 ? span.firstChild : null;
    if (!txt) return;
    var v = inp.value;
    if (/energy/i.test(title)) {
      var svg = arrow(v, SCALE);
      if (svg) {
        var w = el('span', 'eu-fl-ar', svg + '<span class="eu-sr">Energy class ' + esc(v.replace(/^Rating_/i, '')) + '</span>');
        span.replaceChild(w, txt);
      }
    } else if (v === 'true') txt.nodeValue = 'Yes';
    else if (v === 'false') txt.nodeValue = 'No';
    span.setAttribute('data-eu', '1');
  }
  function filters() {
    Array.prototype.forEach.call(d.querySelectorAll('#snize_results .snize-product-filters-block'), function (b) {
      var tEl = b.querySelector('.snize-product-filters-title span') || b.querySelector('.snize-product-filters-title');
      var title = (tEl && tEl.textContent || '').trim();
      var ins = b.querySelectorAll('input.snize-product-filters-checkbox');
      if (/^discount$/i.test(title) || (/^product type$/i.test(title) && ins.length < 2)) { if (b.style.display !== 'none') b.style.display = 'none'; return; }
      if (/^energy rating$/i.test(title) && tEl && tEl.children.length === 0) tEl.textContent = 'Energy class';
      Array.prototype.forEach.call(ins, function (inp) { fixInput(inp, title); });
    });
    /* Searchanise's phone filter dialog (outside #snize_results): the same hidden filters, names and arrows */
    var dlg = d.getElementById('snize-modal-mobile-filters-dialog');
    if (dlg) {
      /* Searchanise draws some filter rows outside its list, so they stayed on screen over an open filter (live has
         this too). Back inside the list, they hide with it. */
      var box = d.getElementById('snize_filters_block');
      if (box) Array.prototype.forEach.call(dlg.querySelectorAll('.snize-modal-content > .snize-product-filter-row'), function (r) { box.appendChild(r); });
      Array.prototype.forEach.call(dlg.querySelectorAll('.snize-product-filter-opener[data-se-facet-attribute]'), function (o) {
        var a = o.getAttribute('data-se-facet-attribute'), row = o.closest('.snize-product-filter-row') || o, hide = a === 'discount_relative';
        if (a === 'product_type') { var c = d.getElementById('snize_product_filter_product_type'); hide = !!c && c.querySelectorAll('input[type=checkbox]').length < 2; }
        if (hide && row.style.display !== 'none') row.style.display = 'none';
      });
      Array.prototype.forEach.call(dlg.querySelectorAll('.snize-product-filter-title, .snize-product-filters-title'), function (t) {
        if (t.children.length === 0 && /^energy rating$/i.test(t.textContent.trim())) t.textContent = 'Energy class';
      });
      Array.prototype.forEach.call(dlg.querySelectorAll('input.snize-product-filters-checkbox'), function (inp) { fixInput(inp, facetTitle(inp.name)); });
    }
  }

  /* ---------- 5. results bar ---------- */
  var SORT_HIDE = /^(title: a-z|title: z-a|date: old to new)$/i;
  var SORT_NAME = { 'date: new to old': 'Newest', 'price: low to high': 'Price: low to high', 'price: high to low': 'Price: high to low', 'discount: high to low': 'Discount: high to low' };
  function sortTidy() {
    Array.prototype.forEach.call(d.querySelectorAll('.snize-main-panel-dropdown-content a, #dropdown-button > span'), function (a) {
      var t = a.textContent.trim();
      if (a.tagName === 'A' && SORT_HIDE.test(t)) { if (a.parentNode.style.display !== 'none') a.parentNode.style.display = 'none'; return; }
      var n = SORT_NAME[t.toLowerCase()];
      if (n && a.children.length === 0) a.textContent = n;
    });
  }
  function enc(ps) { var a = []; ps.forEach(function (v, k) { a.push(encodeURIComponent(k) + '=' + encodeURIComponent(v)); }); return a.length ? '?' + a.join('&') : ''; }
  function tileFor(q) {
    var r = '';
    Array.prototype.forEach.call(d.querySelectorAll('.eu-top [data-eu-q]'), function (a) { if (!r && a.getAttribute('data-eu-q') === q) r = ((a.querySelector('.eu-tl') || a).textContent || '').trim(); });
    return r;
  }
  function euro(n) { n = +n; return '\u20ac' + (Math.round(n * 100) % 100 ? n.toFixed(2) : String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ',')); }
  function chipList() {
    var out = [];
    new URLSearchParams(location.search).forEach(function (v, k) {
      if (k.indexOf('rb_') !== 0 || !v || k === 'rb_vendor') return;   /* brands show in the brand row (user, 17 Oct 2026) */
      var name = k.slice(3), tile = tileFor(k + '=' + v);
      if (tile) { out.push({ k: k, label: tile }); return; }
      var title = facetTitle(name);
      if (/^-?[\d.]+,-?[\d.]+$/.test(v)) {   /* a range: price or a slider */
        var p = v.split(','), unit = (title.match(/\(([^)]+)\)\s*$/) || [])[1] || '', base = title.replace(/\s*\([^)]*\)\s*$/, '');
        out.push({ k: k, label: name === 'price' ? euro(p[0]) + ' \u2013 ' + euro(p[1]) : (base ? base + ' ' : '') + p[0] + '\u2013' + p[1] + (unit ? ' ' + unit : '') });
        return;
      }
      v.split('|').forEach(function (x) {
        var lab = x;
        if (name === 'tags') lab = x.replace(/^[^_]*_/, '');
        else if (/energy/i.test(title) || /^rating_/i.test(x)) lab = 'Energy class ' + x.replace(/^rating_/i, '');
        else if (x === 'true') lab = title || 'Yes';
        else if (x === 'false') lab = title ? 'No ' + title.toLowerCase() : 'No';
        out.push({ k: k, v: x, label: lab });
      });
    });
    return out;
  }
  function without(c) {
    var ps = new URLSearchParams(location.search);
    ps.delete('page');
    if (c.v != null) {
      var rest = (ps.get(c.k) || '').split('|').filter(function (x) { return x !== c.v; });
      if (rest.length) ps.set(c.k, rest.join('|')); else ps.delete(c.k);
    } else ps.delete(c.k);
    return location.pathname + enc(ps);
  }
  function clearAll() {
    var keep = new URLSearchParams();
    new URLSearchParams(location.search).forEach(function (v, k) { if (k.indexOf('rb_') !== 0 && k !== 'page') keep.append(k, v); });
    return location.pathname + enc(keep);
  }
  var XS = '<svg viewBox="0 0 24 24" width="12" height="12" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>';
  function rbar() {
    var mp = d.querySelector('#snize_results .snize-main-panel');
    if (!mp) return;
    var b = mp.querySelector('.snize-main-panel-collection-results-found b'), n = b ? b.textContent.trim() : '';
    var cs = chipList(), sig = location.search + '|' + n + '|' + cs.map(function (c) { return c.label; }).join(',');
    var bar = mp.querySelector(':scope > .eu-rbar');
    if (bar && bar.getAttribute('data-sig') === sig) return;
    if (!bar) { bar = el('div', 'eu-rbar'); mp.insertBefore(bar, mp.firstChild); }
    bar.setAttribute('data-sig', sig);
    var h = n ? '<p class="eu-rcount" aria-live="polite"><b>' + esc(n) + '</b> ' + (n === '1' ? 'product' : 'products') + '</p>' : '';
    if (cs.length) {
      h += '<div class="eu-chips">' + cs.map(function (c) {
        return '<a class="eu-chip" href="' + esc(without(c)) + '" data-k="' + esc(c.k) + '"' + (c.v != null ? ' data-v="' + esc(c.v) + '"' : '') +
          ' aria-label="Remove filter: ' + esc(c.label) + '"><span>' + esc(c.label) + '</span>' + XS + '</a>';
      }).join('') + '<a class="eu-clear" href="' + esc(clearAll()) + '">Clear all</a></div>';
    }
    bar.innerHTML = h;
  }
  /* a chip whose filter has a tick box in the sidebar unticks it (Searchanise updates in place); others reload */
  d.addEventListener('click', function (e) {
    var c = e.target.closest ? e.target.closest('.eu-chip[data-v]') : null;
    if (!c) return;
    var name = c.getAttribute('data-k').slice(3), v = c.getAttribute('data-v'), hit = null;
    Array.prototype.forEach.call(d.querySelectorAll('#snize_results .snize-filters-sidebar input.snize-product-filters-checkbox'), function (i) { if (!hit && i.name === name && i.value === v && i.checked) hit = i; });
    if (hit && hit.offsetParent) { e.preventDefault(); hit.click(); }
  });

  /* ---------- 6. brand row ---------- */
  function vendorList() { var v = new URLSearchParams(location.search).get('rb_vendor'); return v ? v.split('|') : []; }
  function brandHref(b) {
    var ps = new URLSearchParams(location.search), list = vendorList(), i = list.indexOf(b);
    ps.delete('page');
    if (i >= 0) list.splice(i, 1); else list.push(b);
    if (list.length) ps.set('rb_vendor', list.join('|')); else ps.delete('rb_vendor');
    return location.pathname + enc(ps);
  }
  function markBrands() {
    /* only brands Searchanise can show right now (its brand filter's values), so a brand never leads to an empty list;
       a chosen brand always stays. Until Searchanise has drawn its filters, every brand shows. */
    var list = vendorList(), avail = {}, n = 0;
    Array.prototype.forEach.call(d.querySelectorAll('input.snize-product-filters-checkbox[name="vendor"]'), function (i) { if (!avail[i.value]) { avail[i.value] = 1; n++; } });
    Array.prototype.forEach.call(d.querySelectorAll('.eu-br [data-eu-brand]'), function (a) {
      var b = a.getAttribute('data-eu-brand'), on = list.indexOf(b) >= 0, h = brandHref(b), gone = n > 0 && !on && !avail[b];
      if (a.classList.contains('is-gone') !== gone) a.classList.toggle('is-gone', gone);
      if (a.classList.contains('is-on') !== on) a.classList.toggle('is-on', on);
      if (on && a.getAttribute('aria-current') !== 'true') a.setAttribute('aria-current', 'true');
      if (!on && a.hasAttribute('aria-current')) a.removeAttribute('aria-current');
      if (a.getAttribute('href') !== h) a.setAttribute('href', h);
    });
  }
  /* where the sidebar shows the brand's tick box, tick it: Searchanise updates the list in place, no reload */
  d.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('.eu-br [data-eu-brand]') : null;
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var b = a.getAttribute('data-eu-brand'), hit = null;
    Array.prototype.forEach.call(d.querySelectorAll('#snize_results .snize-filters-sidebar input.snize-product-filters-checkbox'), function (i) { if (!hit && i.name === 'vendor' && i.value === b) hit = i; });
    if (hit && hit.offsetParent) { e.preventDefault(); hit.click(); }
  });

  /* ---------- run ---------- */
  var tm = 0;
  function all() { decorate(); prices(); fill(); stock(); moreBar(); filters(); sortTidy(); rbar(); markTiles(); markBrands(); moveFinder(); }
  function soon() { clearTimeout(tm); tm = setTimeout(all, 120); }
  new MutationObserver(soon).observe(d.body, { childList: true, subtree: true });
  load().then(all, function () { DATA = DATA || {}; all(); });
  all();
  var n = 0, iv = setInterval(function () { if (moveFinder() || ++n > 40) clearInterval(iv); }, 250);
})();
